<template>
    <div>
        <Breadcrumb section-name="Report" :breadcrumb="breadCrumb"></Breadcrumb>
        <div class="col-12">
            <div class="card mb-0">
                <div class="card-body">
                    <div class="row mb-3 g-2 align-items-end">
                        <div class="col-auto">
                            <a class="btn btn-option" href="javascript:void(0)" @click="downloadFile">
                                <img v-if="!exportLoading" class="print" width="16" height="16"/>
                                <span v-if="exportLoading" class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
                            </a>
                        </div>
                        <div class="col-md-3 form-group mb-0">
                            <select class="form-control" v-model="params.project_id" name="project_id">
                                <option value="">Select Project</option>
                                <option v-for="each in projects" :value="each.id" v-text="each.name"></option>
                            </select>
                        </div>
                        <div class="col-md-2 form-group mb-0">
                            <flat-pickr class="form-control" placeholder="Start Date" name="start_date"
                                v-model="params.start_date"
                                :config="{dateFormat: 'Y-m-d', altInput: true, altFormat:'d/m/Y'}"/>
                        </div>
                        <div class="col-md-2 form-group mb-0">
                            <flat-pickr class="form-control" placeholder="End Date" name="end_date"
                                v-model="params.end_date"
                                :config="{dateFormat: 'Y-m-d', altInput: true, altFormat:'d/m/Y'}"/>
                        </div>
                        <div class="col-md-2">
                            <button class="btn btn-inverse-primary w-100" @click="fetchBalanceSheetData">Search</button>
                        </div>
                    </div>
                </div>
                <div class="card-body">
                    <div class="table-height long-scroll">
                        <table class="table mb-0 table-striped table-bordered dataTable">
                            <thead>
                                <tr>
                                    <th style="width: 5%">SL</th>
                                    <th style="width: 10%">Date</th>
                                    <th style="width: 20%">Particular</th>
                                    <th style="width: 10%" class="text-end">Income</th>
                                    <th style="width: 10%" class="text-end">Expense</th>
                                    <th style="width: 30%">Remarks</th>
                                    <th style="width: 15%">Shareholder Name</th>
                                </tr>
                            </thead>
                            <tbody v-if="!tblData.loading && tblData.rows.length > 0">
                                <tr v-for="(each,index) in tblData.rows">
                                    <td style="width: 5%" v-text="(index + 1)"></td>
                                    <td style="width: 10%" v-text="each.date"></td>
                                    <td style="width: 20%" v-text="each.category_name"></td>
                                    <td style="width: 10%" class="text-end" v-text="each.type === 'income' ? each.amount : ''"></td>
                                    <td style="width: 10%" class="text-end" v-text="each.type === 'expense' ? each.amount : ''"></td>
                                    <td style="width: 30%" v-text="each.remarks"></td>
                                    <td style="width: 15%" v-text="each.shareholder_name"></td>
                                </tr>
                            </tbody>
                            <tfoot v-if="!tblData.loading && tblData.rows.length > 0">
                                <tr>
                                    <th colspan="3">Total</th>
                                    <th class="text-end" v-text="tblData.total.income"></th>
                                    <th class="text-end" v-text="tblData.total.expense"></th>
                                </tr>
                            </tfoot>
                            <tbody v-if="tblData.loading">
                            <tr>
                                <td colspan="100" class="loader-height">
                                    <Loader></Loader>
                                </td>
                            </tr>
                            </tbody>
                            <tbody v-if="!tblData.loading && tblData.rows.length === 0">
                            <tr class="text-center">
                                <td colspan="100" class="fw-bold fs-6 text-height">
                                    No Data Found
                                    <br>
                                    {{ tblData.noDataError }}
                                </td>
                            </tr>
                            </tbody>
                        </table>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<style scoped>

</style>
<script>
import Breadcrumb from "../Common/Breadcrumb.vue";
import ApiService from "../../Services/ApiService";
import PrintService from "../../Services/PrintService";
import ApiRoutes from "../../Services/ApiRoutes";
import Loader from "../Common/Loader.vue";
export default {
    components: {Loader, Breadcrumb},
    data() {
        return {
            params: {
                project_id: '',
                start_date: '',
                end_date: ''
            },
            breadCrumb: ['Balance Sheet'],
            tblData: {
                loading: false,
                rows: [],
                noDataError: 'Please select any Date',
                total: {}
            },
            projects: [],
            exportLoading: false,
        }
    },
    methods: {
        downloadFile: function () {
            PrintService.print('/report/balance-sheet/print?project_id=' + this.params.project_id + '&start_date=' + this.params.start_date + '&end_date=' + this.params.end_date);
        },
        fetchProject: function() {
            ApiService.POST(ApiRoutes.Project + '/list', {limit: 100}, (res) => {
                if (parseInt(res.status) === 200) {
                    this.projects = res.data.data;
                }
            });
        },
        fetchBalanceSheetData: function() {
            this.tblData.loading = true;
            ApiService.POST(ApiRoutes.Report + '/balance-sheet', this.params, (res) => {
                this.tblData.loading = false;
                if (parseInt(res.status) === 200) {
                    this.tblData.rows = res.data;
                    this.tblData.total = res.total;
                }
            });
        }
    },
    created() {
        if (this.$route.query.project_id !== undefined && this.$route.query.project_id) {
            this.params.project_id = this.$route.query.project_id;
            this.fetchBalanceSheetData();
        }
        this.fetchProject();
        this.fetchBalanceSheetData();
    }
}
</script>
<style lang="scss">
.text-height {
    height: 67vh;
    padding-top: 20px !important;
}
</style>
